<div id="box-menu">
  <div id="toggle-btn-big-screen" class="no-select" (click)="toggleMenu()">
    @if (menuVisible){
    <svg-icon src="./icon/left.svg"></svg-icon>
    }@else {
    <svg-icon src="./icon/right.svg"></svg-icon>
    }
  </div>

  <div id="toggle-btn-small-screen" class="no-select" (click)="toggleMenu()">
    @if (!menuVisible){
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.339916 15.6478C0.122268 15.4222 0 15.1163 0 14.7974C0 14.4784 0.122268 14.1725 0.339916 13.947L6.08669 7.99274L0.339916 2.03852C0.128436 1.81166 0.0114169 1.50781 0.014062 1.19242C0.0167072 0.87703 0.138805 0.575334 0.354058 0.352312C0.56931 0.12929 0.860495 0.00278612 1.1649 4.5472e-05C1.4693 -0.00269517 1.76256 0.118547 1.98152 0.33766L8.5491 7.14231C8.76675 7.36788 8.88901 7.67378 8.88901 7.99274C8.88901 8.3117 8.76675 8.6176 8.5491 8.84317L1.98152 15.6478C1.76381 15.8733 1.46856 16 1.16072 16C0.852871 16 0.557629 15.8733 0.339916 15.6478Z"
        fill="#121212" />
      <path
        d="M7.4509 15.6478C7.23325 15.4222 7.11099 15.1163 7.11099 14.7974C7.11099 14.4784 7.23325 14.1725 7.4509 13.947L13.1977 7.99274L7.4509 2.03852C7.23942 1.81166 7.1224 1.50781 7.12505 1.19242C7.12769 0.87703 7.24979 0.575334 7.46504 0.352312C7.6803 0.12929 7.97148 0.00278612 8.27588 4.5472e-05C8.58028 -0.00269517 8.87355 0.118547 9.09251 0.33766L15.6601 7.14231C15.8777 7.36788 16 7.67378 16 7.99274C16 8.3117 15.8777 8.6176 15.6601 8.84317L9.09251 15.6478C8.87479 15.8733 8.57955 16 8.2717 16C7.96386 16 7.66861 15.8733 7.4509 15.6478Z"
        fill="#121212" />
    </svg>
    }
  </div>

  <div id="slide-menu" class="no-select" [ngClass]="{ open: menuVisible }">
    <div class="menu">
      <div class="menu-header">
        <div class="title">
          <span>{{ 'MENU.EVENTS' | translate }}</span>
          <svg id="toggle-title-small-screen" (click)="menuVisible = false" width="16" height="16" viewBox="0 0 16 16"
            fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.6601 15.6478C15.8777 15.4222 16 15.1163 16 14.7974C16 14.4784 15.8777 14.1725 15.6601 13.947L9.91331 7.99274L15.6601 2.03852C15.8716 1.81166 15.9886 1.50781 15.9859 1.19242C15.9833 0.87703 15.8612 0.575334 15.6459 0.352312C15.4307 0.12929 15.1395 0.00278612 14.8351 4.5472e-05C14.5307 -0.00269517 14.2374 0.118547 14.0185 0.33766L7.4509 7.14231C7.23325 7.36788 7.11099 7.67378 7.11099 7.99274C7.11099 8.3117 7.23325 8.6176 7.4509 8.84317L14.0185 15.6478C14.2362 15.8733 14.5314 16 14.8393 16C15.1471 16 15.4424 15.8733 15.6601 15.6478Z"
              fill="#121212" />
            <path
              d="M8.5491 15.6478C8.76675 15.4222 8.88901 15.1163 8.88901 14.7974C8.88901 14.4784 8.76675 14.1725 8.5491 13.947L2.80232 7.99274L8.5491 2.03852C8.76058 1.81166 8.8776 1.50781 8.87495 1.19242C8.87231 0.87703 8.75021 0.575334 8.53496 0.352312C8.3197 0.12929 8.02852 0.00278612 7.72412 4.5472e-05C7.41972 -0.00269517 7.12645 0.118547 6.90749 0.33766L0.339915 7.14231C0.122267 7.36788 0 7.67378 0 7.99274C0 8.3117 0.122267 8.6176 0.339915 8.84317L6.90749 15.6478C7.12521 15.8733 7.42045 16 7.7283 16C8.03614 16 8.33139 15.8733 8.5491 15.6478Z"
              fill="#121212" />
          </svg>
        </div>

        <div class="search">
          <i class="fas fa-search search-icon"></i>
          <input type="text" [(ngModel)]="filter" (input)="filterList()" placeholder="Search source"
            class="form-control search-input mb-2 ml-8 mr-8" />
        </div>
        <div class="divider"></div>
        <div class="create d-flex justify-content-start">
          <button class="primary-button" [disabled]="btnCreateIsDisabled" (click)="openPopupCreate()">
            <img src="./icon/plus.svg" />
            <span> {{ 'MENU.NEW_EVENT' | translate }} </span>
          </button>
        </div>
      </div>



      <div class="menu-list">

        <div *ngIf="filteredList.length === 0" class="text-muted text-center mt-4 opacity-50 text-size m-4">
          {{
          'MESSAGE_INFO.NO_EVENT_FOUND' | translate
          }}
        </div>

        @for (item of filteredList; track item.id) {
      <div class="row item button-17" 
          [ngClass]="{
            'active': $index === lastSelectedEventIndex && !item.isHidden,
            'is-hidden': item.isHidden
          }"
          (click)="selectEvent(item)">
          <div class="col-10" [ngClass]="{ 'hide': item.isHidden }">
            <div class="row">
              <div class="col-2 align-left ">
                <svg-icon src="./icon/blastMenu.svg" [svgStyle]="{
                  width: '16px',
                  height: '16px'
                }"></svg-icon>
              </div>
              <div class="col-10 text-start p-0"> {{item.name}}</div>
            </div>
            <div class="row">
              <div class="col-2 align-left ">
                <svg-icon src="./icon/project.svg" [svgStyle]="{
                  width: '16px',
                  height: '16x'            
                }"></svg-icon>
              </div>
              <div class="col-10 text-start p-0">{{item.projetLabel}}</div>
            </div>
          </div>
          <div class="col-2">
            <svg-icon src="./icon/visible.svg" (click)="toggleVisibility(item, true); $event.stopPropagation()"
            *ngIf="!item.isHidden" [svgStyle]="{
              width: '16px',
              height: '16px'            
            }"></svg-icon>
            <svg-icon src="./icon/invisible.svg" (click)="toggleVisibility(item, false); $event.stopPropagation()" *ngIf="item.isHidden" [svgStyle]="{
              width: '16px',
              height: '16px'            
            }"></svg-icon>
          </div>
        </div>
        }
      </div>
    </div>
  </div>

  <!-- slide sub menu when control point is selected -->
  <div *ngIf="event && subMenuVisible" id="sub-slide-menu" class="no-select" [ngClass]="{ open: subMenuVisible }">
    <div class="sub-menu-content">
      <div class="projet-infos">
        <div class="row">
          <div class="col-12 d-flex align-items-center">
            <svg-icon src="./icon/project.svg" [svgStyle]="{
              width: '16px',
              height: '16px'            
            }"></svg-icon>
            <span class="ms-2 fs-6 fw-bold"> {{event.projetLabel }}</span><br>
          </div>
        </div>
        <div class="row">
          <div class="d-flex align-items-center ps-3">

            <span>{{event.startDate | date:'yyyy-MM-dd'}} - {{event.endDate | date:'yyyy-MM-dd'}}</span>
          </div>
        </div>
      </div>

      <div class="projet-infos">
        <div class="row">
          <div class="d-flex align-items-center ps-3">
            <span class="fs-5 fw-bold">{{event.name }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-12 d-flex align-items-center">
            <svg-icon src="./icon/blastMenu.svg" [svgStyle]="{
              width: '16px',
              height: '16px'            
            }"></svg-icon>
            <span class="ms-2 "> {{event.eventTypeLabel }}</span><br>
          </div>
        </div>
      </div>
      <div class="button-container">
        <button class="primary-button" (click)="openEventDetail()">{{ 'BUTTONS.DETAILS' | translate }}</button>
        <button class="btn-form secondary-button" (click)="openPopupEditPosition()">
          <img src="icon/edit-pencil.svg" />
          {{ 'BUTTONS.POSITIONS' | translate }}
        </button>
      </div>
    </div>
    <div class="divider"></div>
    <div class="sub-menu-footer" *ngIf="(currentStateService.currentEvent$ | async) as event">
      <div class="container mb-1 mt-2 ms-2 font-size-detail">
        <div class="row">
          <div class="col-md-4">
            <div class="text-start">
              <div class="text-muted">X</div>
              <div>{{transformedCoords?.x}}</div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="text-start">
              <div class="text-muted">Y</div>
              <div>{{transformedCoords?.y}}</div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="text-start">
              <div class="text-muted">Z</div>
              <div>{{event.positionCoordinates?.z}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="divider"></div>

      <div class="record-history-container w-100">
        <div class="title">
          <span>
            {{ 'MENU.RECORDS_HISTORY' | translate }}
          </span>
        </div>
  
        <div class="d-flex">  
          <button *ngIf="vibrationRecords.length > 0" class="ms-3 primary-button col-4" (click)="downloadReport()">
            <img src="icon/report-black.svg" />
            {{'BUTTONS.REPORTS' | translate}}
          </button>
          <button class="secondary-button ms-2 col-7" (click)="onRecordClick()" *ngIf="vibrationRecords.length > 0">
             {{'BUTTONS.NEW_RECORD' | translate}}
          </button>
        </div>
  
  
        <div class="record-history">
          <app-record-history *ngIf="vibrationRecords.length > 0" [vibrationRecords]="vibrationRecords" [event]="event"
            [controlPoints]="controlPoints" [siteId]="currentSite.siteId" [eventId]="currentEventId"></app-record-history>
        </div>
  
        <div class="empty-record-history">
          <div *ngIf="vibrationRecords.length === 0">
            <div class="d-flex flex-column justify-content-center align-items-center content">
              <span class="text-muted opacity-50 mb-2">{{'MESSAGE_INFO.NO_RECORD_FOUND' | translate}}</span>
              <button class="primary-button text-center" (click)="onRecordClick()">
                <span class="text-size">{{'BUTTONS.NEW_RECORD' | translate}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>


      <div *ngIf="(currentStateService.currentEvent$ | async) as event" id="sub-slide-menu-small-screen"
        class="no-select" [ngClass]="{ open: subMenuVisible }">
        <div class="sub-menu-header">
          <div class="projet-infos">
            <div class="row">
              <div class="col-12 d-flex align-items-center">
                <svg-icon src="./icon/project.svg" [svgStyle]="{
            width: '16px',
            height: '16px'            
          }"></svg-icon>
                <span class="ms-2 fs-6 fw-bold"> {{event.projetLabel }}</span><br>
              </div>
            </div>
            <div class="row">
              <div class="d-flex align-items-center ps-3">

                <span>{{event.startDate | date:'yyyy-MM-dd'}} - {{event.endDate | date:'yyyy-MM-dd'}}</span>
              </div>
            </div>
          </div>

          <div class="projet-infos">
            <div class="row">
              <div class="d-flex align-items-center ps-3">
                <span class="fs-6 fw-bold">{{event.name }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex align-items-center">
                <svg-icon src="./icon/blastMenu.svg" [svgStyle]="{
            width: '16px',
            height: '16px'            
          }"></svg-icon>
                <span class="ms-2 "> {{event.eventTypeLabel }}</span><br>
              </div>
            </div>
          </div>
          <div class="flex flex-row m-lg gap-md">
            <button class="btn-form colored-button">{{ 'BUTTONS.DETAILS' | translate }}</button>
            <button class="btn-form" (click)="openPopupEditPosition()">
              <img src="icon/edit-pencil.svg" />
              {{ 'BUTTONS.POSITIONS' | translate }}
            </button>
          </div>
        </div>
        <div class="divider"></div>

        <div class=""></div>
      </div>
    </div>
  </div>